import { render, staticRenderFns } from "./Caminhoes.vue?vue&type=template&id=0644cc3e"
import script from "./Caminhoes.vue?vue&type=script&lang=js"
export * from "./Caminhoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports